export default __webpack_public_path__ + "static/media/Equatorial Guinea.1c555076.png";